import type { BookingStatus } from '@/api';
import type { CabUserBooking } from './api';

interface RideDetails {
	pickup: {
		location: string;
		dateTime: string;
		type: 'location';
	};
	drop: {
		location: string;
		dateTime: string;
		type: 'location';
	};
}

export interface TransformedBookingInfo {
	bookingDetail: {
		bookingId: string;
		bookingStatus: BookingStatus;
		commuteMsg: string;
	};
	rideDetails: RideDetails;
}

export const transformBookingInfo = (
	bookingInfo: CabUserBooking,
): TransformedBookingInfo => {
	return {
		bookingDetail: {
			bookingId: bookingInfo.bookingId,
			bookingStatus: bookingInfo.status,
			commuteMsg: bookingInfo.metadata.ride_details,
		},
		rideDetails: {
			pickup: {
				location: bookingInfo.metadata.pickup_location,
				dateTime: bookingInfo.activityStartTime,
				type: 'location',
			},
			drop: {
				location: bookingInfo.metadata.dropoff_location,
				dateTime: bookingInfo.activityEndTime,
				type: 'location',
			},
		},
	};
};
